import { createI18n } from "vue-i18n"

import { usarIdiomaDoNavegador } from "@/composable/UsarIdiomaDoNavegador/usarIdiomaDoNavegador"
import { idiomas } from "./locales"

type DefaultLanguageSchema = Record<string, any>

const { definirIdioma } = usarIdiomaDoNavegador()

export default createI18n<[DefaultLanguageSchema], "pt-BR" | "es-CO">({
  legacy: false,
  locale: definirIdioma(),
  inheritLocale: false,
  fallbackLocale: "pt-BR",
  globalInjection: true,
  messages: idiomas
})
